import React from "react";
import moment from "moment";
import { getRoutes } from "./RouteHandler";
import { Dashboard, ManageAccounts, Settings, Tune } from "@mui/icons-material";

const menu = [
    {
        id: 'dashboard',
        label: 'Accueil',
        icon: <Dashboard />,
        children: [
            { id: 'admin_dashboard', label: 'Tableau de bord' },
        ]
    },
    {
        id: 'administrator',
        label: 'Administrateur',
        icon: <Settings />,
        children: [
            { id: 'administrator_user_list', label: 'Utilisateurs' },
            { id: 'administrator_role_list', label: 'Rôles' },
            { id: 'administrator_mail_log_list', label: 'Logs emails' },
            { id: 'administrator_cron_log_list', label: 'Logs cron' },
        ]
    },
    {
        id: 'configuration',
        label: 'Configuration',
        icon: <Tune />,
        children: [
            { id: 'configuration_prestation_group_list', label: 'Groupes de prestations' },
            { id: 'configuration_prestation_list', label: 'Prestations' },
            { id: 'configuration_product_list', label: 'Produits' },
            { id: 'configuration_availability_list', label: 'Disponibilités' },
        ]
    },
    {
        id: 'crm',
        label: 'CRM',
        icon: <ManageAccounts />,
        children: [
            { id: 'crm_customer_list', label: 'Gestion clients' },
            { id: 'crm_appointment_list', label: 'Rendez-vous' },
            { id: 'crm_appointment_day', label: "Journée d'aujourd'hui", params: { date: '$today' } },
        ]
    },
];

export const getMenu = () => {
    let routes = getRoutes();
    let menuTmp = [];

    for (let index1 in menu) {
        let children = [];

        for (let index2 in menu[index1].children) {
            const child = menu[index1].children[index2];
            if (routes[child.id]) {
                let c = {
                    ...child,
                    params: child.params ? { ...child.params } : undefined,
                };
                c.path = routes[child.id].path

                if (c.params) {
                    for (let key in c.params) {
                        let value = c.params[key];
                        if (value === '$today') {
                            value = moment().format('YYYY-MM-DD');
                        }

                        if (value) {
                            let regEx = new RegExp(':' + key + '[?]?', 'gi');
                            c.path = c.path.replace(regEx, value);
                        } else {
                            let regEx = new RegExp('/:' + key + '[?]?', 'gi');
                            c.path = c.path.replace(regEx, '');
                        }
                    }
                }

                children.push(c);
            }
        }

        if (children.length > 0) {
            let m = {
                id: menu[index1].id,
                label: menu[index1].label,
                icon: menu[index1].icon,
            };
            m.children = children;
            menuTmp.push(m);
        }
    }

    return menuTmp;
}
